import styled from '@emotion/styled';
import colors from '../../../styling/colors';

export default styled.button`
  background: none;
  border: none;
  color: ${colors('gatsby')};
  font-family: 'Basis';
  margin: 0;
  padding: 0;
  text-decoration: underline;
`;
